import { settingsBreadcrumbs } from '../settings-breadcrumbs';

const notifications_routes = [
  {
    path: 'notifications',
    name: 'notifications',
    meta: {
      breadcrumbs: settingsBreadcrumbs({
        label: 'global.sidebar.notifications_trans',
        route: { name: 's-notifications' },
      }),
    },
    children: [
      {
        path: '',
        name: 's-notifications',
        component: () => import('@/views/System/Settings/Notifications/NotificationsSettings.vue'),
      },
    ],
  },
];

export default notifications_routes;
